enum PageTypes {
  Question = 'question',
  AdditionalQuestions = 'additionalQuestions',
  Timer = 'timer',
  Banner = 'banner',
};

export default PageTypes;